import type { ReflectionSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'
import type { ElementStyleCss } from 'services/Branding/types'

const DownloadButtonStyled = styled.button<{
  $styles: ElementStyleCss<ReflectionSchemaType>
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: ${({ $styles }) => $styles.icon.width};
  height: ${({ $styles }) => $styles.icon.height};
  border-radius: ${({ $styles }) => $styles.icon.borderRadius};
  color: ${({ $styles }) => $styles.icon.color};
  background-color: ${({ $styles }) => $styles.downloadButton.backgroundColor};
  border: none;
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 12px;
  background-image: ${({ $styles }) => $styles?.icon.backgroundImage};
  ${outline}

  &:hover {
    background-color: ${({ $styles }) => $styles.button_hover.backgroundColor};
  }
`

export default DownloadButtonStyled
